import React, { useState } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import PropTypes from 'prop-types';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import PopupHeader from 'Components/PopupHeader/PopupHeader';
import PopupFooter from 'Components/PopupFooter/PopupFooter';
import CustomTextarea from 'Common/CustomTextArea';
import Validator, {
  ValidationTypes as V_Type,
} from "react-form-supervalidator";

const AddPatientPaymentMemoPopup = ({ onClose, disableDraggable, paymentModel,handlePaymentChange, handleApplyPayment }) => {
    const UNIQUE_ID = "AddPatientPaymentMemoPopup"
    const [memoNotes, setMemoNotes] = useState(paymentModel.notes|| "")
    const [validationModel, setValidationModel] = useState({
           memoNoteError: null,
    });
    const setValidation = () => {
        let validationObj = {
            ...validationModel,
            memoNoteError: Validator(
                paymentModel.notes,
                [V_Type.required],
                ["Memo is required"]
            ),
        };
        setValidationModel(validationObj);
        return Validator(validationObj, V_Type.NullCheck);
    };
    const handleClose = () => {
       handlePaymentChange({ target: { name: "notes", value: memoNotes } });
       onClose();
       setMemoNotes("");
    }

    const handleSave = () => {
        let isValid = setValidation();
        if (isValid) return;
        handleApplyPayment()
        onClose();
    }
    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
                    <div data-te-modal-dialog-ref className="relative w-[550px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0 '>
                            <PopupHeader heading= "Memo" uniqueId={UNIQUE_ID} />
                            <div className=" overflow-y-auto max-h-[70vh]">
                                <CustomTextarea
                                    placeholder="Memo"
                                    rows={5}
                                    extraClass="w-full"
                                    name="notes"
                                    value={paymentModel.notes}
                                    onChange={handlePaymentChange}
                                ></CustomTextarea>
                                {validationModel.memoNoteError}
                                <div className="flex justify-end mt-2 text-sm text-slate-500">
                                    <span>{paymentModel.notes?.length}</span>
                                    <span>/ 500</span>
                                </div>
                            </div>

                            <PopupFooter onClose={handleClose} onConfirm={handleSave} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default AddPatientPaymentMemoPopup

AddPatientPaymentMemoPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
};
